module.exports = __webpack_public_path__ + "static/media/login-student-badge-scanner-badge.b8ef768e.png";